import dropdown from './src/Dropdown.vue'
import { withInstall } from '@/utils'

export * from './src/typing'
export const Dropdown = withInstall(dropdown)
